import { render, staticRenderFns } from "./CustomerAttachements.vue?vue&type=template&id=c26c7d1c"
import script from "./CustomerAttachements.vue?vue&type=script&lang=js"
export * from "./CustomerAttachements.vue?vue&type=script&lang=js"
import style0 from "./CustomerAttachements.vue?vue&type=style&index=0&id=c26c7d1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports